import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { getCarSerial } from '../../../../../../services/api';
import EnqueryAlert from '../../../../components/enqueryAlert';

class SeriesPrice extends React.PureComponent {
    // constructor(props) {
    //     super(props);
    //     this.state = { toggleOnIndex: 0 };
    //     // 这边绑定是必要的，这样 `this` 才能在回调函数中使用
    //     this.handleClick = this.handleClick.bind(this);
    //     this.openEnquery = this.openEnquery.bind(this);
    // }

    static propTypes = {
        content: PropTypes.object,
        seriesInfo: PropTypes.object,
        curCity: PropTypes.object,
    };
    state = {
        columnArticleData: [],
        // isEnqueryShow: false,
    };

    async componentDidMount() {
        try {
            if (this.props.content.serialId) {
                const columnArticleData = (await getCarSerial(this.props.content.serialId)).columnArticleData;

                this.setState({
                    columnArticleData,
                });
            }
            // 挂载页面滚动监听
            // window.addEventListener('scroll', this.bindScroll.bind(this));
        } catch (e) {
            console.error(e);
        }
    }

    // componentWillUnmount() {
    //     // 移除页面滚动监听
    //     window.removeEventListener('scroll', this.bindScroll.bind(this));
    // }
    handleClick(index) {
        this.setState(prevState => ({
            toggleOnIndex: index,
        }));
    }
    // openEnquery() {
    //     this.setState(() => ({
    //         isEnqueryShow: true,
    //     }));

    // }
    // bindScroll(event) {
    //     console.log('scdscds');
    //     // 滚动的高度
    //     const scrollTop = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) || window.pageYOffset || (event.srcElement ? event.srcElement.body.scrollTop : 0);
    //     // 视窗高度
    //     const clientHeight = (event.srcElement && event.srcElement.documentElement.clientHeight) || document.body.clientHeight;
    //     // 页面高度
    //     const scrollHeight = (event.srcElement && event.srcElement.documentElement.scrollHeight) || document.body.scrollHeight;
    //     // 距离页面底部的高度
    //     const height = scrollHeight - scrollTop - clientHeight;

    //     // 判断距离页面底部的高度
    //     if (height <= 0) {
    //         // 判断执行回调条件
    //         if (this.state.codeType) {
    //             // 执行回调

    //             // 关闭判断执行开关
    //             this.setState(
    //                 {
    //                     isFixed: false,
    //                 }
    //             );
    //         }
    //     } else {
    //         // 打开判断执行开关
    //         this.setState({
    //             isFixed: true,
    //         });
    //     }
    // }

    render() {
        const { content, seriesInfo, curCity } = this.props;
        const { columnArticleData } = this.state;

        return (
            <div>
                {content && seriesInfo && seriesInfo.serialLogo ? (
                    <div className={styles.floatboxt1}>
                        <div className={styles.arl_rs_tit}>
                            <h3>
                                <a
                                    target="_blank"
                                    rel={rel}
                                    title={seriesInfo.standardName}
                                    href={`https://car.auto.ifeng.com/series/${content.serialId}/`}>
                                    {seriesInfo.standardName}
                                </a>
                            </h3>
                            <div className={styles.more}>
                                <a
                                    target="_blank"
                                    rel={rel}
                                    className={styles.b}
                                    title={`${seriesInfo.standardName}询最低价 `}
                                    href={`https://auto.ifeng.com/xunjia/index.shtml?b=${content.brandId}&s=${
                                        content.serialId
                                    }`}>
                                    询最低价
                                </a>
                            </div>
                        </div>
                        <div className={styles.serialprice}>
                            <div className={styles.arl_c_det}>
                                <div className={styles.pic}>
                                    <a
                                        className={styles.img}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://car.auto.ifeng.com/series/${content.serialId}/`}
                                        title={seriesInfo.standardName}>
                                        <img src={seriesInfo.serialLogo} alt={seriesInfo.standardName} />
                                    </a>
                                    <a
                                        className={styles.nb}
                                        title={`${seriesInfo.standardName}车系图片 `}
                                        target="_blank"
                                        rel={rel}
                                        href={`https://data.auto.ifeng.com/photo/s-${content.serialId}.html`}>
                                        共
                                        <span>{seriesInfo.picCount}</span>张图片
                                    </a>
                                </div>
                                <div className={styles.data}>
                                    <div className={styles.data_item}>
                                        <label>指导价：</label>
                                        <a
                                            title={seriesInfo.standardName}
                                            href={`https://data.auto.ifeng.com/price/s-${content.serialId}.html`}
                                            target="_blank"
                                            rel={rel}>
                                            {seriesInfo.guidePrice}
                                        </a>
                                        万
                                    </div>
                                    <div className={styles.data_item}>
                                        <label>级　别：</label> {seriesInfo.level}
                                    </div>
                                    <div className={styles.data_item}>
                                        <label>发动机：</label>
                                        {seriesInfo.carExhaustVolume.map((item, index) => (
                                            <span key={index}>{item}</span>
                                        ))}
                                    </div>
                                    <div className={styles.data_item}>
                                        <label>变速箱：</label>
                                        {seriesInfo.biansuxiang.map((item, index) => <span key={index}>{item}</span>)}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.arl_llink}>
                                <a
                                    title={`${seriesInfo.standardName}车系首页 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://car.auto.ifeng.com/series/${content.serialId}/`}>
                                    车系首页
                                </a>
                                <a
                                    title={`${seriesInfo.standardName}参数配置 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://car.auto.ifeng.com/series/${content.serialId}/spec/`}>
                                    参数配置
                                </a>
                                <a
                                    title={`${seriesInfo.standardName}实拍图片 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://data.auto.ifeng.com/photo/s-${content.serialId}.html`}>
                                    实拍图片
                                </a>
                                <a
                                    title={`${seriesInfo.standardName}报价 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://data.auto.ifeng.com/price/s-${content.serialId}.html`}>
                                    报价
                                </a>
                                <a
                                    title={`${seriesInfo.standardName}报价 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://car.auto.ifeng.com/series/${content.serialId}/news/`}>
                                    文章
                                </a>
                            </div>
                            {columnArticleData.length > 0 ? (
                                <div className={styles.arl_llist}>
                                    <ul>
                                        {columnArticleData.map((item, index) => (
                                            <li key={index}>
                                                {item.columnUrl && item.columnUrl !== '' ? (
                                                    <a target="_blank" rel={rel} href={item.columnUrl}>
                                                        {item.columnName}{' '}
                                                    </a>
                                                ) : (
                                                    ''
                                                )}
                                                {item.columnUrl && item.columnUrl !== '' ? <span>|</span> : ''}

                                                <a
                                                    className={
                                                        item.columnUrl && item.columnUrl !== '' ? styles.a2 : styles.a3
                                                    }
                                                    target="_blank"
                                                    rel={rel}
                                                    href={item.url}>
                                                    {item.title}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        {/* {isEnqueryShow ? <EnqueryAlert curCity={curCity} /> : ''} */}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(SeriesPrice);
